/**
 * ODDFISH — Services main page animations (AOS + scroll reveals)
 */
(function () {
  "use strict";

  function initAOS() {
    if (window.oddfishAosInit || typeof AOS === "undefined") return false;
    AOS.init({
      once: true,
      duration: 800,
      easing: "ease-out-cubic",
      offset: 120,
      disable: false
    });
    window.oddfishAosInit = true;
    return true;
  }

  function markNoAosFallback() {
    document.querySelectorAll(".oddfish-services-main").forEach(function (el) {
      el.classList.add("no-aos");
    });
  }

  function initServicesPage(root) {
    if (!root || root.dataset.oddfishServicesPageInit) return;
    root.dataset.oddfishServicesPageInit = "true";

    if (!initAOS()) {
      setTimeout(function () {
        if (!initAOS()) markNoAosFallback();
      }, 1500);
    }

    var animateSections = root.querySelectorAll(".animate");
    if (!animateSections.length) return;

    var ticking = false;

    function handleScroll() {
      var windowBottom = window.scrollY + window.innerHeight;

      animateSections.forEach(function (section) {
        var rect = section.getBoundingClientRect();
        var sectionTop = window.scrollY + rect.top;
        var sectionBottom = sectionTop + rect.height - 50;

        if (windowBottom > sectionBottom) {
          section.classList.add("scrolled");
          section.querySelectorAll(".strike").forEach(function (el) {
            el.classList.add("strike-visible");
          });
        }
      });
    }

    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          requestAnimationFrame(function () {
            handleScroll();
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );

    handleScroll();
  }

  function scan() {
    document.querySelectorAll(".oddfish-services-main").forEach(initServicesPage);
  }

  function boot() {
    scan();
    if (typeof AOS === "undefined") {
      window.addEventListener("load", function () {
        initAOS();
        scan();
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function () {
    window.oddfishAosInit = false;
    boot();
  });
})();
